export const gtWalsheimFamily = '"Gt Walsheim", Roboto, sans-serif';
export const robotoFamily = 'Roboto, sans-serif';
const fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
};
const typography = {
    fontFamily: robotoFamily,
    fontWeightLight: fontWeights.light,
    fontWeightRegular: fontWeights.regular,
    fontWeightMedium: fontWeights.medium,
    fontWeightBold: fontWeights.bold,
    h1: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '92px',
        letterSpacing: -1.5,
    },
    h2: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '58px',
        letterSpacing: -0.5,
    },
    h3: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '48px',
    },
    h4: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '34px',
        letterSpacing: 0.25,
    },
    h5: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '24px',
    },
    h6: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.medium,
        fontSize: '20px',
        letterSpacing: 0.25,
    },
    body1: {
        // Roboto
        fontWeight: fontWeights.medium,
        fontSize: '16px',
        letterSpacing: 0.5,
        lineHeight: '28px',
    },
    body2: {
        // Roboto
        fontWeight: fontWeights.medium,
        fontSize: '14px',
        letterSpacing: 0.25,
        lineHeight: '20px',
    },
    subtitle1: {
        // Roboto
        fontWeight: fontWeights.medium,
        fontSize: '16px',
        letterSpacing: 0.25,
        lineHeight: '24px',
    },
    subtitle2: {
        // Roboto
        fontWeight: fontWeights.medium,
        fontSize: '14px',
        letterSpacing: 0.1,
        lineHeight: '24px',
    },
    button: {
        fontFamily: gtWalsheimFamily,
        fontWeight: fontWeights.bold,
        fontSize: '14px',
        letterSpacing: 1.5,
        lineHeight: '16px',
    },
    caption: {
        // Roboto
        fontWeight: fontWeights.bold,
        fontSize: '12px',
        letterSpacing: 0.5,
        lineHeight: '16px',
    },
    overline: {
        // Roboto
        fontWeight: fontWeights.bold,
        fontSize: '12px',
        letterSpacing: 2,
        lineHeight: '16px',
    },
};
export default typography;
//# sourceMappingURL=typography.js.map